export const environment = {
  production: false,
  app_version: "1.0.36",
  app_name: "BoG PRO DEV",
  bucket: "performance-reports-bucket",
  redirectUrl: "https://bog-deeplink.web.app/",
  x_api_key: "AIzaSyDtDvF-hLlwUcOO-UnJkEyufxm_5PMUk0s",
  nativeMapKey: "AIzaSyBydobE8SQAJ-PG27Wj5IyYMS1qD6N1AP8",
  browserMapKey: "AIzaSyAsHlYP4yGwXBYzJRGbinwmq_qPl4pDMtI",
  // url: "http://localhost:5001/global-expert-app-staging/europe-west2/",
  url: "https://global-bog-pro-dev-23d9pxrd.uc.gateway.dev/",
  bogUrl: "https://global-bog-staging-3jkqtie0.nw.gateway.dev/",
  tinymiceditor_apiKey: "klq1d1ftym4ruw76sogrc2nc2q6cbq541oju0ahhippf24ym",
  inc_numberUrl: "https://eu3.nonprod.ehssrisk.com/holcim-dev/view/Incident",

  calendar_scope: "https://www.googleapis.com/auth/calendar",
  calendar_client_secret: "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",
  calendar_redirect_uri:
    "https://global-bog-pro-dev-23d9pxrd.uc.gateway.dev/googleCalendarAuth",
  calendar_client_id:
    "164061062185-qacppbda8hi996e9laskhsg3in25j9mh.apps.googleusercontent.com",

  google_picker_api_key: "AIzaSyCfJe5OjjtXr3y1CSWDHkPU2kpd-V11HbE",
  google_picker_client_id:
    "728976855742-slikdpgb4jt6f6pm2m9ik5277kskme6o.apps.googleusercontent.com",
  google_picker_app_id: "728976855742",

  google_web_client_id:
    "164061062185-8rop8npcfkpoap7168ec1kb0hrqmfofn.apps.googleusercontent.com",
  google_ios_client_id:
    "164061062185-567pv90n5accgj8747oiqc6crhmrfgb9.apps.googleusercontent.com",
};

export const firebaseConfig = {
  measurementId: "G-2D1S2SSGJ1",
  messagingSenderId: "164061062185",
  projectId: "global-expert-app-staging",
  apiKey: "AIzaSyAWcZjvEIiyTaMYdZW41GpFn_dnU6k6qPI",
  appId: "1:164061062185:web:9e0328d08d3cf32d18e838",
  storageBucket: "global-expert-app-staging.appspot.com",
  authDomain: "global-expert-app-staging.firebaseapp.com",
  databaseURL: "https://global-expert-app-staging-default-rtdb.firebaseio.com",
};
